export default __webpack_public_path__ + "static/media/srisailamAboutOne.17cf82e3.jpg";